import { QuizQuestion } from '@shared/types';
import ReactPhoneInput from 'react-phone-number-input'
import { useT } from '../../lib/i18n';
import { getDefaultPhoneCountry } from '../../lib/phoneCountry';

interface PhoneInputProps {
  question: QuizQuestion;
  value: string;
  onChange: (value: string) => void;
  onFinished?: (value: string) => void;
}

export default function PhoneInput({ question, value = '', onChange, onFinished }: PhoneInputProps) {
  const { t, language } = useT();
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && value.length >= 10) {
      onFinished?.(value);
    }
  };

  const handleBlur = () => {
    if (value.length >= 10) {
      onFinished?.(value);
    }
  };

  return (
    <div>
      <ReactPhoneInput
        defaultCountry={getDefaultPhoneCountry(language) as never}
        placeholder={question.placeholder || t('quiz.questions.phone.placeholder')}
        value={value}
        onChange={(value) => onChange(value?.toString() || '')}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        className="input text-xl leading-none p-2"
      />
      <p className="text-sm text-dark-muted mt-2">
        {t('quiz.phoneHelper')}
      </p>
    </div>
  );
}
